import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { ui } = constants.colors;
const { mediaQuery: breakpoint } = mediaQueryStyles;

export const containerCss = {
  backgroundColor: ui.neutral[25],
  borderRadius: 10,
  width: 288,
  height: "max-content",
  padding: 10,
  [breakpoint.upTo("xs")]: {
    width: "100%",
  },
  h4: {
    ...typographyStyles.heading4,
    fontSize: "20px",
    lineHeight: "120%",
    fontWeight: "bold",
    margin: "10px",
  },
};

export const schoolListCss = {
  listStyleType: "none",
  padding: "0 10px 10px 10px",
  margin: 0,
  p: {
    margin: 0,
  },
  li: {
    margin: "5px 0",
  },
};

export const changeSchoolButtonCss = {
  root: {
    marginTop: 15,
  },
};
